export const FixedImageQcFieldName = 'fixedImageQcFieldComponent';
